import React from "react";
import { initialsOf } from "../utils/people";

/** Round initials avatar (the network and team APIs return no photos). */
const PersonAvatar = ({ person, size = 44 }) => (
  <span className="pn-avatar" style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }} aria-hidden="true">
    {initialsOf(person)}
  </span>
);

export default PersonAvatar;
